import Vue from 'vue'
import axios from 'axios'

// export const address = 'http://test3.kencoo.com:8888' // 服务地址
export const address = 'https://data.piyaps.com:8888' // 服务地址

// 获取可以服务节点
export let findWsUrl = async () => {
  let res = await axios.get(address + '/connector/node?protocol=WS')
  return res.data.data
}

// 客服上线
export let goLive = (userId) => {
  return new Promise((resolve, reject) => {
    axios.get(address + '/customerService/goLive/' + userId).then(res => {
      resolve(res.data.data)
    })
  })
}

// 客服下线
export let downLive = (userId) => {
  return new Promise((resolve, reject) => {
    axios.get(address + '/customerService/downLive/' + userId).then(res => {
      resolve(res.data.data)
    })
  })
}

// 查询客服在线状态
export let getStatus = (userId) => {
  return new Promise((resolve, reject) => {
    axios.get(address + '/customerService/getStatus/' + userId).then(res => {
      resolve(res.data)
    })
  })
}

// 查询聊天列表
export let customerServiceList = (userId, type, name) => {
  return new Promise((resolve, reject) => {
    axios.get(address + '/customerService/list/' + userId + '/' + type + '/' + name).then(res => {
      resolve(res.data)
    })
  })
}

// 查询聊天列表详情
export let chatHistory = (id) => {
  return new Promise((resolve, reject) => {
    axios.get(address + '/customerService/chatHistory/' + id).then(res => {
      resolve(res.data)
    })
  })
}

// 发送消息
export let sendMessage = (data) => {
  return new Promise((resolve, reject) => {
    axios.post(address + '/piyaIm/send', data).then(res => {
      resolve(res.data)
    })
  })
}

// 接入客服
export let accessingCustomers = (id, userId) => {
  return new Promise((resolve, reject) => {
    axios.get(address + '/customerService/accessingCustomers/' + id + '/' + userId).then(res => {
      resolve(res.data)
    })
  })
}

// 获取离线未接用户数量
export let offlineMissedConnection = () => {
  return new Promise((resolve, reject) => {
    axios.get(address + '/customerService/offlineMissedConnection/').then(res => {
      resolve(res.data)
    })
  })
}

export let sendImageMessage = (form) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: address + '/piyaIm/sendImageMessage/',
      data: form
    }).then(res => {
      resolve(res.data)
    })
  })
}
